// extracted by mini-css-extract-plugin
export default {"modal":"face-capture-screen_modal__h3dnL","modalImage":"face-capture-screen_modalImage__mF2zQ"};